var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"file-container",domProps:{"innerHTML":_vm._s(_vm.fileContent)}})
}
var staticRenderFns = []

export { render, staticRenderFns }